var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinumStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ybedaorbxa",
    x1: 0.5,
    y1: 0.379,
    x2: -0.078,
    y2: 1.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "mf3jfm3ryb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 46",
    d: "M26.183 3.957a2 2 0 0 1 3.635 0l5.972 13a2 2 0 0 0 1.59 1.152l14.256 1.632a2 2 0 0 1 1.122 3.463L42.2 32.855a2 2 0 0 0-.611 1.875l2.844 13.989a2 2 0 0 1-2.933 2.142l-12.521-7.029a2 2 0 0 0-1.959 0L14.5 50.861a2 2 0 0 1-2.939-2.142l2.844-13.989a2 2 0 0 0-.611-1.875L3.243 23.208a2 2 0 0 1 1.122-3.463l14.255-1.633a2 2 0 0 0 1.59-1.152z",
    transform: "translate(1300 1530)",
    style: {
      fill: "url(#ybedaorbxa)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8427"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 27",
    d: "M26.183 3.957a2 2 0 0 1 3.635 0l5.972 13a2 2 0 0 0 1.59 1.152l14.256 1.632a2 2 0 0 1 1.122 3.463L42.2 32.855a2 2 0 0 0-.611 1.875l2.844 13.989a2 2 0 0 1-2.933 2.142l-12.521-7.029a2 2 0 0 0-1.959 0L14.5 50.861a2 2 0 0 1-2.939-2.142l2.844-13.989a2 2 0 0 0-.611-1.875L3.243 23.208a2 2 0 0 1 1.122-3.463l14.255-1.633a2 2 0 0 0 1.59-1.152z",
    style: {
      fill: "url(#ybedaorbxa)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 145",
    style: {
      clipPath: "url(#mf3jfm3ryb)"
    },
    transform: "translate(-1300 -1530)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8275",
    style: {
      opacity: 0.554
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45296",
    d: "m1302.31 1755.671 25.476 11.671-29.635-5.4z",
    transform: "rotate(26 1778.196 1672.003)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45298",
    d: "M4.159 11.671 29.635 0 0 5.4z",
    transform: "rotate(-16 6207.436 -3851.076)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45297",
    d: "m1302.31 1755.671 25.476 11.671-29.635-5.4z",
    transform: "rotate(118 1389.335 1662.726)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45299",
    d: "M4.159 11.671 29.634 0 0 5.4z",
    transform: "scale(-1) rotate(51 981.825 -2198.786)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45300",
    d: "M4.159 11.671 29.634 0 0 5.4z",
    transform: "rotate(-73.98 1712.034 -83.258)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumStarIcon);
export default __webpack_public_path__ + "static/media/PlatinumStarIcon.f8be8d6672ac0208ec86584d672de17f.svg";
export { ForwardRef as ReactComponent };